/* eslint-disable no-useless-escape */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable max-len */
export const generateSearchApiParameters = (pixel) => {
  const parameterInformation = [
    {
      parameter: 'pid',
      type: 'string',
      required: 'YES',
      description: `This is the Pixel ID of your website. Your Pixel ID is: <b>${pixel.data && pixel.data.uuid}</b>`,
      default: ''
    },
    {
      parameter: 'userip',
      type: 'string',
      required: 'YES',
      description: 'Your users IP Address. Do not use the same IP address for multiple users. You should be retrieving a different IP address for each different user',
      default: ''
    },
    {
      parameter: 'useragent',
      type: 'string',
      required: 'YES',
      description: 'The useragent your user is using to access your backend. This is often a web browser or a mobile app. The useragent could be a web browser such as Google Chrome, or Mozilla Firefox',
      default: ''
    },
    {
      parameter: 'q',
      type: 'string',
      required: 'YES',
      description: `The search keyword. This can be a job title, company name or industry. Either <b>q</b> or <b>l</b> 
      or <b>category</b> must be present`,
      default: ''
    },
    {
      parameter: 'l',
      type: 'string',
      required: 'YES',
      description: `The search location. This can be a city, region or zipcode. Either <b>q</b> or <b>l</b> 
      or <b>category</b> must be present`,
      default: ''
    },
    {
      parameter: 'bool',
      type: 'integer',
      required: 'OPTIONAL',
      description: `By default, all terms in parameter <b>'q'</b> are optional, as long as one term matches. A search for <b>'digital marketing'</b> will find any document that contains one or more of digital or marketing. But when <b>'bool'</b> parameter is set to <b>'1'</b>, there are boolean operators which can be used in the parameter <b>'q'</b> itself to provide more control.

        <br/><br/>The preferred operators are <b>+ (this term must be present)</b> and <b>- (this term must not be present)</b>. All other terms are optional. For example, this query:

        <br/><br/><b>digital marketing +sales -outside</b>

        <br/><br/>states that:

        <br/><br/><b>sales</b> must be present
        <br/><br/><b>outside</b> must not be present
        <br/><br/><b>digital and marketing</b> are optional — their presence increases the relevance

        <br/><br/>The familiar boolean operators <b>AND, OR and NOT (also written &&, || and !)</b> are also supported but beware that they do not honor the usual precedence rules, so parentheses should be used whenever multiple operators are used together. For instance the previous query could be rewritten as:

        <br/><br/><b>((digital AND sales) OR (marketing AND sales) OR sales) AND NOT outside</b>


        <br/><br/><b>Use the bool feature with caution:</b>

        <br/><br/><b>1.</b> It may not always work as expected since we use synonyms while indexing the jobs into our search engine.
        <br/><br/><b>2.</b> If the reservered characters (<b>+ - = && || > < ! ( ) { } [ ] ^ " ~ * ? : \ /</b>) are passed in the <b>'q'</b> parameter without escaping and if they are found not to be part of the boolean logic itself, then it will result in unexpected results/errors.</b>
        <br/><br/><b>3.</b> It might also slow down the query.`,
      default: '0'
    },
    {
      parameter: 'min_cpc',
      type: 'float',
      required: 'OPTIONAL',
      description: 'The minimum cpc filter for the jobs returned in the search results',
      default: '0.10'
    },
    {
      parameter: 'page',
      type: 'integer',
      required: 'OPTIONAL',
      description: 'The page number of the search results you want to retrieve.',
      default: '1'
    },
    {
      parameter: 'limit',
      type: 'integer',
      required: 'OPTIONAL',
      description: 'Maximum number of results to return per query. The maximum allowed is <b>100</b> and minimum is <b>1</b>.',
      default: '15'
    },
    {
      parameter: 'radius',
      type: 'integer',
      required: 'OPTIONAL',
      description: 'Distance from the search location in <b>miles</b> (point-to-point aerial transit path, or "as the bird flies").',
      default: '25'
    },
    {
      parameter: 'sort',
      type: 'string',
      required: 'OPTIONAL',
      description: 'Sort by <b>relevance</b> or <b>date</b> or <b>cpc</b>',
      default: 'relevance'
    },
    {
      parameter: 'id',
      type: 'string',
      required: 'OPTIONAL',
      description: 'Ids of the specific jobs you want to retrieve separated by a pipe. For example: <b>123|345|678</b>',
      default: ''
    },
    {
      parameter: 'category',
      type: 'string',
      required: 'OPTIONAL',
      description: `Category filter for the jobs returned in the search results. Available options are:
          <br/><br/>1. Architecture and Engineering Occupations
          <br/>2. Arts, Design, Entertainment, Sports, and Media Occupations
          <br/>3. Building and Grounds Cleaning and Maintenance Occupations
          <br/>4. Business and Financial Operations Occupations
          <br/>5. Community and Social Service Occupations
          <br/>6. Computer and Mathematical Occupations
          <br/>7. Construction and Extraction Occupations
          <br/>8. Education, Training, and Library Occupations
          <br/>9. Farming, Fishing, and Forestry Occupations
          <br/>10. Food Preparation and Serving Related Occupations
          <br/>11. Healthcare Practitioners and Technical Occupations
          <br/>12. Healthcare Support Occupations
          <br/>13. Installation, Maintenance, and Repair Occupations
          <br/>14. Legal Occupations
          <br/>15. Life, Physical, and Social Science Occupations
          <br/>16. Management Occupations
          <br/>17. Military Specific Occupations
          <br/>18. Office and Administrative Support Occupations
          <br/>19. Personal Care and Service Occupations
          <br/>20. Production Occupations
          <br/>21. Protective Service Occupations
          <br/>22. Sales and Related Occupations
          <br/>23. Transportation and Material Moving Occupations
          <br/><br/> You can pass multiple categories separated by a pipe. For example: <b>Sales and Related Occupations|Production Occupations</b>`,
      default: ''
    },
    {
      parameter: 'fields',
      type: 'string',
      required: 'OPTIONAL',
      description: `Fields to search for the jobs returned in the search results. Available options are:
          <br/><br/>1. title
          <br/>2. description
          <br/>3. company
          <br/><br/> You can pass multiple fields seperated by a pipe. For example: <b>title|description</b></b>`,
      default: 'title|description|company'
    },
    {
      parameter: 'full_desc',
      type: 'integer',
      required: 'OPTIONAL',
      description: 'Set this to <b>1</b> to return full job description. This may slow down the response of the request',
      default: '0'
    },
    {
      parameter: 'use_userip',
      type: 'integer',
      required: 'OPTIONAL',
      description: 'Set this to <b>1</b> to get results based on the location determined by <b>userip</b> when the location parameter <b>l</b> is blank.',
      default: '0'
    }
  ];

  return parameterInformation;
};
